import { Cart } from '../cart'
import { CartItem } from '../cart-item'
import { CartItemRepository } from '../repository/cart-item-repository'
import { DefaultDealWithItemViaCartSpec } from '../specification/deal-with-item-via-cart/default-deal-with-item-via-cart-spec'
import {
  CommandResult,
  CommandResultContainer,
  DealWithItemViaCartSpec
} from '../specification/deal-with-item-via-cart/index'
import { itemShouldExistInCart } from './assertion'

/**
 * カートから指定の商品を削除する際の手続き内容と、
 * 手続き実行時に参照するルールを記述する.
 */
export default class RemoveItemFromCartService {
  static create(repository: CartItemRepository): RemoveItemFromCartService {
    return new RemoveItemFromCartService(
      repository,
      new DefaultDealWithItemViaCartSpec()
    )
  }
  private constructor(
    private readonly repository: CartItemRepository,
    private readonly dealWithItemSpec: DealWithItemViaCartSpec
  ) { }

  remove(item: CartItem, from: Cart): Promise<CommandResult> {
    const remove = this.dealWithItemSpec.apply(async (itemOnRun, cartOnRun) => {
      try {
        itemShouldExistInCart(itemOnRun, cartOnRun)

        /**
         * 親子商品には集約的な制約があるが、カートリソースとしては親子商品が等しく露出している。
         * client側のコードで集約が表現されるまでは、集約のルートとして機能する親商品に対してのみアクションを実行可能とする。
         */
        if (itemOnRun.isChild) {
          throw new Error(`Remove should not be called for child item(${itemOnRun.id})`)
        }

        return this.repository.remove(itemOnRun).then(result => result.fold<CommandResult>(
          error => CommandResultContainer.createAsFail([error]),
          () => CommandResultContainer.createAsSuccess({
            ...itemOnRun,
            removed: true,
          })
        ))
      } catch (e) {
        return CommandResultContainer.createAsFail([e])
      }
    })

    return remove(item, from)
  }

  async removeSome(items: CartItem[], from: Cart): Promise<CommandResult> {
    const results = await Promise.all(items.map(item => this.remove(item, from)))

    return results.reduce(
      (prev: CommandResult, result: CommandResult) => prev.and(result),
      CommandResultContainer.empty()
    )
  }
}
